import { render } from "./Cod1Page.vue?vue&type=template&id=691f76f2&scoped=true"
import script from "./Cod1Page.vue?vue&type=script&lang=js"
export * from "./Cod1Page.vue?vue&type=script&lang=js"

import "./Cod1Page.vue?vue&type=style&index=0&id=691f76f2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691f76f2"]])

export default __exports__